import { render, staticRenderFns } from "./filters-modal-form.vue?vue&type=template&id=793f0ac2&scoped=true"
import script from "./filters-modal-form.vue?vue&type=script&lang=js"
export * from "./filters-modal-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793f0ac2",
  null
  
)

export default component.exports